<template>
  <CartCheckoutWrapper class="basket-item-detail" v-if="selectedLine">
    <b-container id="basket-item-detail">
        <div id="item-detail-layout">

          <!-- item preview with thumbnails -->

          <div col-sm-12 col-lg-7 id="images">
            <h1 class="product-title">
              <router-link to="/cart"><i class="fas fa-chevron-left"/>
              {{selectedLine.product.title}}</router-link>
            </h1>
            <LineItemPreview @edit="editDesign" :line="selectedLine"/>
          </div>

          <!-- right side movees under preview -->

        <div class="col-sm-12 col-lg-5" id="sidebar">

        
        <!-- code from basketItemDetail.vue that needs to move into fixed menu -->


          <div id="details">

            <!-- checkout card -->

            <div class="action-card actions d-none d-lg-block" id="check-out">
              <h2>Ready to proceed?</h2>
              <hr/>
              <p>Press the button below when you are ready to check out.</p>
              <hr/>  <!-- where did this go? -->
              <div class="button-wrapper">
                  <router-link to="/cart" class="btn-action" style="margin-bottom: 12px;">
                    Cart
                    <i class="fa fa-arrow-right"></i>
                  </router-link>
              </div>
            </div>

            <!-- edit details card -->

            <div class="action-card actions" id="action-form">
              <div class="details-title"><i class="fa fa-arrow-down"/>&nbsp;Edit Details</div>
                <LineItemProductForm :line="selectedLine"/>
                <div class="more-actions">
                  <button @click="orderAnother" class="btn remove-from-cart"><i class="far fa-clone" /> Order Another</button>
                  <button @click="removeItem" class="btn remove-from-cart"><i class="far fa-trash-alt"/> Remove Item</button>
                </div>
              </div>
            </div>
          

        </div>  <!-- end details -->

        <!-- fixed menu at bottom -->

        <div class="fixed-menu d-lg-none">
          <div class="fixed-menu-wrapper">
            <div class="btn-hint">
              <a href="mailto:support@brandly.com">Need help?</a>
            </div>
            <router-link to="/cart" class="btn-action" style="margin-bottom: 12px;">
            Cart<i class="fa fa-arrow-right"></i>
            </router-link> 
          </div>
        </div>

      </div><!-- end item-detail-layout -->  
    </b-container>
  </CartCheckoutWrapper>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import LineItemProductForm from "./LineItemProductForm";
export default {
  components: { LineItemProductForm },
  created() {
    let { id } = this.$route.params;
    this.loadSelectedLine({ id: +id });
  },
  computed: {
    ...mapGetters(["selectedLine", "selectedProductIsRounded", "designId"])
  },
  methods: {
    ...mapActions([
      "loadSelectedLine",
      "removeFromCart",
      "duplicateLineAndDesign"
    ]),
    async orderAnother() {
      await this.duplicateLineAndDesign(this.selectedLine);
      this.$router.push({ name: "Editor", params: { id: this.designId } });
    },
    editDesign() {
      this.$router.push({
        name: "Editor",
        params: { id: this.selectedLine.designId }
      });
    },
    async removeItem() {
      await this.removeFromCart(this.selectedLine);
      this.$router.push({ name: "Cart" });
    }
  }
};
</script>
<style lang="scss" scoped>
@import '~scss/colors';


#item-detail-layout{
  height:100%;
}

//product-title - link back to cart

.product-title {
  padding: 1em;
  max-width: 630px;
  margin: 2em auto 3em auto;
  zoom: 80%;
  border-radius: 5px;
  border: get-theme-color("accent", "thumbnail") 1px solid;
}
.product-title:hover {
  background: white;
  box-shadow: 2px 4px 2px $gray-1;
  cursor: pointer;
}

// left side: product image preview - including thumbnails

#images img {
  background: white;
  margin: 20px;
  max-width: 504px;
  display: block;
}
#images.roundedCorners img {
  border-radius: 18px;
}

// right side - edit details

#item-detail-layout .actions {
  width:560px;
  margin: 2.5em auto 0 auto;
  max-width: 100%;
  zoom: 90%;
}

#details {
  margin-top: 2em;
  display: flex;
  flex-direction: column-reverse;
  min-width: 420px;
}

#action-form{
position:relative;
}

.details-title {
  position: absolute;
  top:-2.5em;
  left:0;
  font-family: "Proxima Nova";
  font-size: calc (13pt / 0.9);
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: rgb(50, 50, 55);
  width: 100%;
}

// right side - edit details: order another/remove

.more-actions {
  display: flex;
  width: auto;
  max-width: 405px;
  justify-content: space-between;
  margin: 1em;
}

.button-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 25px;
}

// right side - checkout

#check-out {
  display: block;
  text-align: center;
  & h2 {
    font-size: 150%;
  }
  & p {
    font-size: 120%;
  }
}

.btn-action {
  font-size: 110% !important;
}

.below-button {
  text-align: center;
  margin: 0;
  padding: 0;
  a {
    color: get-theme-color("accent");
    font-weight: bold;
  }
}

.basket-item-detail h1 {
  font-size: 20px;
}

#item-detail-layout {
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
}

.fixed-menu {
  padding: 1em;
&-wrapper{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height:42px;
  width:504px;
  margin:0 auto;
  }
}
.btn-hint{
  padding: 0;
& a{
  line-height: 2.5em;
  }
}

// medium devices

@media (max-width: 1000px) {
  #item-detail-layout{
    height:1300px;
    }
  #images {
    height:500px;
    }
  #item-detail-layout .actions {
    width:504px;
    margin: 0 auto;
    zoom: 100%;
    }
  #action-form{
    position:relative;
  }
  .details-title {
    position: absolute;
    top:-2.5em;
    left:0; 
}
  }

// small devices

@media (max-width: 550px) {
  #item-detail-layout .actions {
    width:100%;
    margin: 2em auto 0 auto;
    max-width: 100%;
    zoom: 100%;
  }
  #images {
    height:0;
  }
  #sidebar {
    padding:0 !important;
    margin:0 !important;
    }
  #details {
    display: block;
    min-width: 0;
    max-width:100%;
    margin: 0 auto;
    }
  .details-title {
    font-size: 7pt;
    top:-2.5em;
    left:0;
}
  #action-form {
    display: block;
    margin: 0 auto;
    width:100% !important;
    }
  .product-title {
    width: auto;
    zoom: 66%;
    padding: 0.5em;
    margin: 1em 1.2em;
    }
  .line-item-preview {
    zoom: 66%; //this cntrols the width of the previw and thumbnails
    margin: 0 auto;
  }
  #product-form {
    zoom: 70%;
    margin: 0 auto;
  }
  .more-actions {
    display: block;
    margin: 0 auto 1em auto;
  }
  .remove-from-cart {
    display: inline-block;
    width: 100%;
    justify-content: center;
    margin: 1em auto;
  }
  .fixed-menu {
  padding: 1em 0;
&-wrapper{
  width:340px;
  }
}
}
</style>



// WEBPACK FOOTER //
// src/components/pages/basket/BasketItemDetail.vue